import { PriceCalculator } from "./price_calculator.js";

export function buildConstructorPayload({ state, quote, estimatedCostLabel, clientName, phoneNumber }) {
  const priceDetails = quote.rows.map(
    (row) => `${row.label} — ${PriceCalculator.formatAmount(row.amount)} ${quote.symbol}`
  );

  priceDetails.push("");
  priceDetails.push(`${estimatedCostLabel} ${PriceCalculator.formatAmount(quote.total)} ${quote.symbol}`);

  return {
    location: state.location,
    projectCategory: state.projectCategory,
    room: state.area > 0 ? String(state.area) : "",
    projectType: state.projectTypeLabel || state.projectType,
    details: priceDetails.join("\n"),
    totalPrice: state.area > 0 ? `${PriceCalculator.formatAmount(quote.total)} ${quote.symbol}` : "—",
    clientName,
    phoneNumber,
  };
}
